const state = {
  menuOpen: false,
  languages: ['pt', 'en', 'es', 'fr'],
  defaultLanguage: 'pt'
}

const getters = {
  menuOpen: (state) => state.menuOpen,
  Languages: (state) => state.languages,
  DefaultLanguage: (state) => state.defaultLanguage
}

const mutations = {
  toggle (state, payload) {
    if (typeof payload === 'boolean') {
      state.menuOpen = payload
    } else {
      state.menuOpen = !state.menuOpen
    }
  }
}

const actions = {
  toggleMenu ({ state, commit }, stateMenu) {
    commit('toggle', stateMenu)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/config.js